import { createApiClient } from "../utilities/apiClient";
import { useQuery } from "@tanstack/react-query";
import { IFileItem } from "../declarations";

const getCertificateFiles = async (orderID: number, coOrderItemID: string): Promise<IFileItem[]> => {
    const axiosSailTag = createApiClient();
    const response = await axiosSailTag.get<IFileItem[]>(
        `/api/Cert/GetCertificateList/${orderID}/${encodeURIComponent(coOrderItemID)}`
    );
    return response.data;
};

export const useGetCertificateFiles = (orderID: number, coOrderItemID: string) =>
    useQuery<IFileItem[]>({
        queryKey: [
            "GetCertificateFiles",
            {
                orderID,
                coOrderItemID,
            },
        ],
        queryFn: () => {
            return getCertificateFiles(orderID, coOrderItemID);
        },
        enabled: orderID > 0 && Boolean(coOrderItemID?.trim()),
        refetchOnWindowFocus: true,
        retry: false,
    });
